import styled from 'styled-components'

export const SimulationContainer = styled.div`
  margin: 0;
  padding: 0;

  .messageContainer,
  .DFaccordionBox {
    text-align: left;
    background-color: ${({ isFullStop }: { isFullStop: boolean }) =>
      isFullStop ? '#ef5350' : '#fc9e00'};
  }
`

export const Title = styled.h1`
  font-family: 'Ubuntu', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.15em;
  text-align: center;
  color: #1f1f1f;
`

export const SubTitle = styled.h2`
  font-family: 'Ubuntu', sans-serif;
  font-size: 29px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.01em;
  text-align: center;
  color: #646464;
  padding-top: 20px;
`

export const ProgressBarContainer = styled.div`
  padding-top: 20px;
  display: flex;
  justify-content: center;
  max-width: 1024px;
  width: 100%;
  margin: auto;
`

export const Divider = styled.div`
  padding-top: 20px;
`

export const TitleContainer = styled.div``

export const SimulationResultsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: Ubuntu;
`

export const SimulationDataContainer = styled.div``

export const SimulationDataElements = styled.div``
